import { render, staticRenderFns } from "./MyVip.vue?vue&type=template&id=a46caa08&"
import script from "./MyVip.vue?vue&type=script&lang=js&"
export * from "./MyVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports